import { memo } from 'react';
import { Checkbox } from '@ds';
import { AdminFormRow } from '@ui';
import { OpoRoleEnum } from '@/api/apis/customer';
import { OPO_CONTACT_ROLE_NAMES } from '@/constants/customer.constants';
import { ControlledCheckboxGroup } from '../../components/inputs/ControlledCheckboxGroup';

const ALL_OPO_ROLES = Object.values(OpoRoleEnum);

type OpoRoleSelectorProps = {
  name: string;
  roleValues: OpoRoleEnum[];
  onChange: (roles: string[]) => void;
  isReadOnly?: boolean;
  isRequired?: boolean;
};

export const OpoRoleSelector = memo(
  ({ name, roleValues, onChange, isReadOnly = false, isRequired = false }: OpoRoleSelectorProps) => {
    return (
      <AdminFormRow title="Role" inputWrapperClass="max-w-240" isRequired={isRequired}>
        <ControlledCheckboxGroup
          name={name}
          orientation="horizontal"
          value={roleValues}
          onChange={onChange}
          isDisabled={isReadOnly}
        >
          {ALL_OPO_ROLES.map((role) => (
            <Checkbox size="md" value={role} className="p-0 m-2" isDisabled={isReadOnly} key={role}>
              {OPO_CONTACT_ROLE_NAMES[role]}
            </Checkbox>
          ))}
        </ControlledCheckboxGroup>
      </AdminFormRow>
    );
  },
);

OpoRoleSelector.displayName = 'OpoRoleSelector';
